// // import { useEffect } from "react";
// // import { useNavigate, useSearchParams } from "react-router-dom";
// // import { useAuth } from "../../Context/AuthContext";


// // export default function LoginSuccess() {
// //   const navigate = useNavigate();
// //   const { login } = useAuth();
// //   const [params] = useSearchParams();

// //   useEffect(() => {
// //     const token = params.get("token");

// //     if (!token) {
// //       navigate("/login", { replace: true });
// //       return;
// //     }

// //     // خزّن التوكن
// //     localStorage.setItem("token", token);

// //     // امسح التوكن من الرابط
// //     const url = new URL(window.location.href);
// //     url.searchParams.delete("token");
// //     window.history.replaceState({}, "", url.toString());

// //     // حدّث الـ auth context (لو login عندك بيقبل user null)
// //     login(null, token);

// //     // روح للصفحة اللي تحبها
// //     navigate("/", { replace: true });
// //   }, [login, navigate, params]);

// //   return <div style={{ padding: 24 }}>جاري تسجيل الدخول...</div>;
// // }

// import { useEffect } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { useAuth } from "../../Context/AuthContext";

// export default function LoginSuccess() {
//   const navigate = useNavigate();
//   const { login } = useAuth();
//   const [params] = useSearchParams();

//   useEffect(() => {
//     const token = params.get("token");
//     const userParam = params.get("user");

//     if (!token || !userParam) {
//       navigate("/login", { replace: true });
//       return;
//     }

//     let user = null;

//     try {
//       // فك تشفير + تحويل JSON
//       user = JSON.parse(decodeURIComponent(userParam));
//     } catch (e) {
//       console.error("Invalid user data in URL", e);
//       navigate("/login", { replace: true });
//       return;
//     }

//     // ✅ تخزين
//     localStorage.setItem("token", token);
//     localStorage.setItem("user", JSON.stringify(user));

//     // ✅ تحديث الـ AuthContext
//     login(user, token);

//     // ✅ مسح البيانات من الـ URL
//     const url = new URL(window.location.href);
//     url.searchParams.delete("token");
//     url.searchParams.delete("user");
//     window.history.replaceState({}, "", url.toString());

//     // ✅ تحويل حسب نوع المستخدم
//     const role = user?.type || user?.role;
//     if (role === "admin") {
//       navigate("/admin/dashboard", { replace: true });
//     } else if (role === "client") {
//       navigate("/myorders", { replace: true });
//     } else {
//       navigate("/", { replace: true });
//     }
//   }, [login, navigate, params]);

//   return <div style={{ padding: 24 }}>جاري تسجيل الدخول...</div>;
// }
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";

export default function LoginSuccess() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [params] = useSearchParams();

  // helper: decode query param safely (+ => space)
  const decodeParam = (v) => {
    if (!v) return "";
    try {
      return decodeURIComponent(String(v).replace(/\+/g, " "));
    } catch {
      // لو فيه مشكلة decode، رجّع النص زي ما هو
      return String(v).replace(/\+/g, " ");
    }
  };

  useEffect(() => {
    const token = params.get("token");

    // 1) حاول تجيب user JSON
    const userParam = params.get("user");
    let user = null;

    if (userParam) {
      try {
        const decoded = decodeParam(userParam);
        user = JSON.parse(decoded);
      } catch (e) {
        console.error("Invalid user JSON in URL:", e);
        // هنسيبها null ونحاول fallback
      }
    }

    // 2) fallback: لو الباك بيرجع name/email/type منفصلين
    if (!user) {
      const name = decodeParam(params.get("name"));
      const email = decodeParam(params.get("email"));
      const type = decodeParam(params.get("type")) || decodeParam(params.get("role"));

      // لو مفيش بيانات كفاية، اعتبرها فشل
      if (!name && !email) {
        // لو التوكن مش موجود كمان يبقى رجّع login
        if (!token) {
          navigate("/login", { replace: true });
          return;
        }
        // لو فيه token بس ومفيش user، تقدر تختار:
        // - تخلي user = null وتكمل
        // - أو ترجع login
        // هنا هنكمل بـ user minimal
      }

      user = {
        name: name || "",
        email: email || "",
        type: type || "user",
      };
    }

    // لو مفيش token خالص يبقى ماينفعش
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    // ✅ خزّن الاتنين
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    console.log("token:", localStorage.getItem("token"));
console.log("user:", JSON.parse(localStorage.getItem("user")));


    // ✅ حدّث الكونتكست
    login(user, token);

    // ✅ امسح البيانات الحساسة من الرابط (token/user/name/email/type/role)
    const url = new URL(window.location.href);
    ["token", "user", "name", "email", "type", "role"].forEach((k) => url.searchParams.delete(k));
    window.history.replaceState({}, "", url.toString());

    // ✅ redirect حسب الدور
    const role = user?.type || user?.role;
    if (role === "admin") navigate("/admin/dashboard", { replace: true });
    else if (role === "client") navigate("/myorders", { replace: true });
    else navigate("/", { replace: true });
  }, [login, navigate, params]);

  return <div style={{ padding: 24 }}>جاري تسجيل الدخول...</div>;
}
